import React from 'react'

const ProjectDetails = () => {
  return (
    <div>
      
    </div>
  )
}

export default ProjectDetails
